import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "layers-thin",
  "use": "layers-thin-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"layers-thin\">\n  <path fill-rule=\"evenodd\" d=\"M185,201h1v12h-1V201Zm11,0h1v12h-1V201Zm-11,0h12v1H185v-1Zm0,11h12v1H185v-1Zm5-15h1v5h-1v-5Zm11,0h1v12h-1V197Zm-11,0h12v1H190v-1Zm6,11h6v1h-6v-1Z\" transform=\"translate(-185 -197)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/layers-thin.svg
// module id = null
// module chunks = 